export const TRANSLATE_SELFIE = {
  FEEDBACK_RETRY: 'Não foi possível concluir. Tente novamente.',
  FEEDBACK_RETRY_INSECURE: 'Alimentação de câmera insegura',
  FEEDBACK_RETRY_QUALITY: 'Não foi possível concluir. Tente novamente.',
  FEEDBACK_ENROLLED: 'Registrado com sucesso',
  FEEDBACK_CAPTURED: 'Capturado com sucesso',
  FEEDBACK_NOT_ENROLLED: 'Usuário não inscrito',
  FEEDBACK_VERIFY_COMPLETED: 'Verificação bem-sucedida',
  FEEDBACK_VERIFY_FAILED: 'Falha na verificação',
  FEEDBACK_SEARCHING: 'Pesquisando...',
  FEEDBACK_INSIDE_GUIDE: 'Centralize seu rosto',
  FEEDBACK_PLEASE_HOLD: 'Mantenha-se imóvel',
  FEEDBACK_STABLE: 'Mantenha-se imóvel',
  FEEDBACK_EYE_LEVEL: 'Olhe para a câmera',
  FEEDBACK_UP_FACING: 'Olhe para baixo para ficar paralelo à câmera',
  FEEDBACK_DOWN_FACING: 'Olhe para cima para ficar paralelo à câmera',
  FEEDBACK_FACE_OUTSIDE: 'Centralize seu rosto',
  FEEDBACK_CLOSE: 'Afaste um pouco',
  FEEDBACK_FAR: 'Chegue um pouco mais perto',
  FEEDBACK_LEFT_FACING: 'Olhe para a câmera',
  FEEDBACK_RIGHT_FACING: 'Olhe para a câmera',
  FEEDBACK_ROTATED: 'Olhe para a câmera',
  FEEDBACK_NOT_STABLE: 'Mantenha-se imóvel',
  FEEDBACK_OK: 'Ótimo, continue assim',
  FEEDBACK_NO: 'Validando...',
  FEEDBACK_NOT_CENTERED: 'Centralize seu rosto',
  FEEDBACK_CAMERA_ACQUIRING_FAILED: 'Não é possível adquirir a câmera, permitir permissão ou tentar capturar novamente',
  FEEDBACK_PROCESSING: 'Validando...',
  FEEDBACK_UPLOAD_FAILURE: 'Não foi possível concluir. Tente novamente.',
  FEEDBACK_INITIALIZATION: 'Inicializando...',
  FEEDBACK_CHANGE_LIGHT: 'Evite sombras',
  FEEDBACK_CHANGE_LIGHT_TOO_BRIGHT: 'Evite luz direta no rosto',
  FEEDBACK_CHANGE_LIGHT_TOO_DARK: 'Procure um lugar mais iluminado',
  FEEDBACK_BUTTON_CLOSE: 'Fechar',
  FEEDBACK_BUTTON_RETRY: 'Tentar novamente',
  FEEDBACK_TRAINING_BUTTON_NEXT: 'Próximo',
  FEEDBACK_TRAINING_LABEL: 'Não mostrar novamente',
  FEEDBACK_ORIENTATION_NOT_SUPPORTED: 'Apenas o modo Retrato é suportado',
  FEEDBACK_TRAINING_DIALOG_CLOSED: 'Diálogo de treinamento, encerrado',
  FEEDBACK_LICENCE_INVALID: 'Licença inválida!!',
  // Checagens ICAO em tempo real (precaptureChecks, SDK >= 6.3.0).
  // Sem estas chaves o SDK exibe o texto em inglês durante a captura.
  FEEDBACK_OPEN_EYES: 'Abra os olhos',
  FEEDBACK_CLOSE_MOUTH: 'Feche a boca',
  FEEDBACK_REMOVE_GLASSES: 'Tire os óculos',
  FEEDBACK_REMOVE_SUNGLASSES: 'Tire os óculos de sol',
  FEEDBACK_REMOVE_HAT: 'Tire o chapéu ou boné',
  FEEDBACK_REMOVE_MASK: 'Tire a máscara',
  FEEDBACK_REMOVE_HAND: 'Tire a mão do rosto',
  ERROR_BROWSER_NOT_SUPPORTED: 'Navegador não suportado. Use Chrome, Firefox, Opera, Edge (iOS, Android, Desktop), Samsung Internet (Android) ou Safari (iOS, MAC)',
  ERROR_BROWSER_VERSION_NOT_SUPPORTED: 'Versão do navegador não suportada. Atualize para a versão mais recente disponível.',
  ERROR_DEVICE_NOT_SUPPORTED: 'Dispositivo não suportado, use um dispositivo móvel ou desktop.',
  ERROR_DEVICE_NOT_SUPPORTED_ANDROID: 'Versão do Android não suportada. Atualize para a versão mais recente disponível',
  ERROR_DEVICE_NOT_SUPPORTED_IOS: 'Versão IOS não suportada. Atualize para a versão mais recente disponível',
  ERROR_DEVICE_NOT_SUPPORTED_MEMORY: 'Dispositivo não suportado. Memória insuficiente',
  ERROR_PLATFORM_NOT_SUPPORTED_ANDROID: 'Versão do Android não suportada. Atualize para a versão mais recente disponível',
  ERROR_PLATFORM_NOT_SUPPORTED_IOS: 'Versão IOS não suportada para este navegador. Atualize para a versão mais recente disponível',
  ERROR_BROWSER_FEATURE_NOT_SUPPORTED: 'TextDecoder ou Crypto API não presente.',
  ERROR_WEBRTC_NOT_SUPPORTED: 'Webrtc não suportado',
  ERROR_MODEL_FAIL: 'Falha na detecção do modelo',
  ERROR_SERVER_INTERNAL: 'Erro interno do servidor',
  ERROR_SERVER_CONNECTION_FAILURE: 'Falha na conexão com o servidor'
}
